import { useEffect, useState } from '@wordpress/element';
import { __, sprintf } from '@wordpress/i18n';

interface CountdownTimerProps {
    time: number; // Time in seconds
    onComplete: () => void; // Callback when countdown completes
    label?: any; // Optional label for the timer
}

const CountdownTimer = ( {
    label = '',
    time = 60, // Default time in seconds
    onComplete,
}: CountdownTimerProps ) => {
    const [ timer, setTimer ] = useState( time );
    useEffect( () => {
        let interval: any;
        if ( timer > 0 ) {
            interval = setInterval( () => {
                setTimer( ( prev ) => {
                    if ( prev <= 1 ) {
                        onComplete();
                        return 0;
                    }
                    return prev - 1;
                } );
            }, 1000 );
        }
        return () => clearInterval( interval );
    }, [ timer, onComplete ] );

    const minutes = Math.floor( timer / 60 );
    const seconds = String( timer % 60 ).padStart( 2, '0' );

    if ( ! label ) {
        return (
            <span className="text-sm text-gray-500">
                {
                    // eslint-disable-next-line @wordpress/valid-sprintf
                    sprintf(
                        // translators: %s: minutes, %s: seconds
                        __( 'Resend in %s:%s', 'dokan' ),
                        minutes,
                        seconds
                    )
                }
            </span>
        );
    }

    return typeof label === 'function'
        ? label( { minutes: String( minutes ), seconds, raw: timer } )
        : label;
};

export default CountdownTimer;
